const onEscape = ({ event, callback, enabled = true }) => {
  if (!enabled) return;
  if (event.key === 'Escape') {
    callback();
  }
};

export default onEscape;
